import { useHistory } from "react-router-dom";
import { Page } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";

import { Header } from "../../components";
import RolePage from "./pages/RolePage";

import { Alert, Snackbar } from "@common-ui/ui";

export const UserRole = () => {
  const orgID = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
    ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
        ?.id
    : undefined;
  const [isPlatformAdmin, setPlatformAdmin] = useState(
    window?.localStorage?.getItem("IS_PLATFORM_ADMIN")
      ? window?.localStorage?.getItem("IS_PLATFORM_ADMIN")
      : ""
  );

  const [toast, setToast] = useState([]);

  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setPlatformAdmin(
          user?.attributes["custom:plat_admin"]
            ? user?.attributes["custom:plat_admin"]
            : ""
        );
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  if (isPlatformAdmin?.toString() === "true") {
    return (
      <Page
        title="FlukeWorks"
        // style={{ backgroundColor: "#fff", minHeight: "calc(100vh - 52px)" }}
      >
        <Header xl name="Update User's Platform Role" history={history} />

        {toast.map((item, id) => {
          return (
            <Snackbar
              key={id}
              open={item.open}
              autoHideDuration={6000}
              onClose={() => {
                setToast(toast.filter((v, i) => i !== id));
              }}
            >
              <Alert
                onClose={() => {
                  setToast(toast.filter((v, i) => i !== id));
                }}
                severity={item.severity}
                sx={{ width: "100%" }}
                variant="filled"
              >
                {item.message}
              </Alert>
            </Snackbar>
          );
        })}

        <RolePage
          history={history}
          orgId={orgID}
          setToast={setToast}
          toast={toast}
        />
      </Page>
    );
  } else {
    history && history.push("/");
    return null;
  }
};
